<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? '新增资方收费标准' : type == 'update' ?'修改资方收费标准' : '资方收费标准'" @close="qx()" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :disabled="allDisabled" :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '140px' : '120px'">
      <div class="line-box">
        <el-form-item class="styW" label="资金方" prop="userId">
          <el-select @change="changeFund" v-model="dataForm.userId" placeholder="请选择" filterable clearable style="width:100%">
              <el-option v-for="(item,index) in fundList" :key="index" :label="item.deptName" :value="item.userId">
              </el-option>
          </el-select>
        </el-form-item>
        <el-form-item  label="生效日期" prop="effectiveDate">
         <div style="display: flex;">
          <el-date-picker
            :disabled="disabled"
            v-model="dataForm.effectiveDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            >
          </el-date-picker>
         </div>
        </el-form-item>
      </div>
      <div class="title">通道费</div>
        <div class="title1">非抵押贷</div>
        <el-form-item  class="styW" label="收费方式" prop="channelFeeDto.productDatas[0].chargeWay" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
          <el-select @change="changeChargeWay" v-model="dataForm.channelFeeDto.productDatas[0].chargeWay" placeholder="请选择" filterable clearable style="width:100%">
            <el-option v-for="(item,index) in chargeWayList" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item v-if="loanType == '一刀切'" class="styW" label="费率" prop="channelFeeDto.productDatas[0].feeConditionDatas[0].feeAmount" :rules="[{ required: true, message: $t('validate.required'), trigger: 'change' },{  pattern: /^[0-9]+(\.[0-9]+)?$/, message: `请输入数字或'.'`, trigger: 'blur' }]">
          
          <div class="rate">
            <el-input v-model="dataForm.channelFeeDto.productDatas[0].feeConditionDatas[0].feeAmount" placeholder="0.00"></el-input>
            <div style="margin-left: 6px;">%</div>
          </div>
        </el-form-item>
        <div v-else>
          <div class="line-box" v-for="(items,index) in dataForm.channelFeeDto.productDatas[0].feeConditionDatas" :key="'non-mortgage'+index">
            <el-form-item class="sandh1" label="条件" :prop="'channelFeeDto.productDatas[0].feeConditionDatas.' + index + '.maxValue'" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }">
              <div class="condition">
                <el-input  @input="inputChange(items,index)" :disabled="items.inputDisabled" class="styW1" v-model="items.minValue" placeholder="￥0.00"></el-input>
                <el-select class="styW2" :disabled="items.selectDisabled" v-model="items.minSymbol"  clearable  placeholder="请选择" >
                  <el-option
                    v-for="(item,i) in conditionList"
                    :key="i"
                    :label="item.label"
                    :value="item.value"
                    >
                  </el-option>
                </el-select>
                <div>{{loanType}}</div>
                <el-select class="styW2" v-model="items.maxSymbol"  clearable  placeholder="请选择" >
                  <el-option
                    v-for="(item,i) in conditionList"
                    :key="i"
                    :label="item.label"
                    :value="item.value"
                    >
                  </el-option>
                </el-select>
                <el-input @input="maxChange(items,index)" @focus="estimateFocus1(items,index)" @blur="estimateBlur1(items,index)" class="styW1" v-model="items.maxValue" placeholder="￥0.00"></el-input>
              </div>
            </el-form-item>
            <el-form-item  label="费率" :prop="'channelFeeDto.productDatas[0].feeConditionDatas.' + index + '.feeAmount'" label-width="60px" :rules="[{ required: true, message: $t('validate.required'), trigger: 'change' },{  pattern: /^[0-9]+(\.[0-9]+)?$/, message: `请输入数字或'.'`, trigger: 'blur' }]">
              <div class="rate">
                <el-input class="styW1" v-model="items.feeAmount" ></el-input>
                <div style="margin-left: 6px;">%</div>
                <div style="margin-left: 20px;" class="add_delete_btn" v-if="!dataForm.id && index == dataForm.channelFeeDto.productDatas[0].feeConditionDatas.length - 1">
                  <img @click="addFee(items,index)" src="../../../assets/img/add_green.svg" alt="">
                  <i @click="deleteFee(items,index)" v-if="dataForm.channelFeeDto.productDatas[0].feeConditionDatas.length>1" class="el-icon-delete deleteIcon"></i>
                </div>
              </div>
            </el-form-item>
          </div>
        </div>
      <div class="title1">抵押贷</div>
      <el-form-item  class="styW" label="收费方式" prop="channelFeeDto.productDatas[1].chargeWay" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
          <el-select @change="changeChargeWay1" v-model="dataForm.channelFeeDto.productDatas[1].chargeWay" placeholder="请选择" filterable clearable style="width:100%">
            <el-option v-for="(item,index) in chargeWayList" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="loanType1 == '一刀切'" class="styW" label="费率" prop="channelFeeDto.productDatas[1].feeConditionDatas[0].feeAmount" :rules="[{ required: true, message: $t('validate.required'), trigger: 'change' },{  pattern: /^[0-9]+(\.[0-9]+)?$/, message: `请输入数字或'.'`, trigger: 'blur' }]">
          <div class="rate">
            <el-input  v-model="dataForm.channelFeeDto.productDatas[1].feeConditionDatas[0].feeAmount" placeholder="0.00"></el-input>
            <div style="margin-left: 6px;">%</div>
          </div>
        </el-form-item>
        <div v-else>
          <div class="line-box" v-for="(items,index) in dataForm.channelFeeDto.productDatas[1].feeConditionDatas" :key="'mortgage'+index">
            <el-form-item class="sandh1" label="条件" :prop="'channelFeeDto.productDatas[1].feeConditionDatas.' + index + '.maxValue'" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }">
              <div class="condition">
                <el-input  @input="inputChange1(items,index)" :disabled="items.inputDisabled" class="styW1" v-model="items.minValue" placeholder="￥0.00"></el-input>
                <el-select class="styW2" :disabled="items.selectDisabled" v-model="items.minSymbol"  clearable  placeholder="请选择" >
                  <el-option
                    v-for="(item,i) in conditionList"
                    :key="i"
                    :label="item.label"
                    :value="item.value"
                    >
                  </el-option>
                </el-select>
                <div>{{loanType1}}</div>
                <el-select class="styW2" v-model="items.maxSymbol"  clearable  placeholder="请选择" >
                  <el-option
                    v-for="(item,i) in conditionList"
                    :key="i"
                    :label="item.label"
                    :value="item.value"
                    >
                  </el-option>
                </el-select>
                <el-input @input="maxChange1(items,index)" @focus="estimateFocus2(items,index)" @blur="estimateBlur2(items,index)" class="styW1" v-model="items.maxValue" placeholder="￥0.00"></el-input>
              </div>
            </el-form-item>
            <el-form-item  label="费率" :prop="'channelFeeDto.productDatas[1].feeConditionDatas.' + index + '.feeAmount'" label-width="60px" :rules="[{ required: true, message: $t('validate.required'), trigger: 'change' },{  pattern: /^[0-9]+(\.[0-9]+)?$/, message: `请输入数字或'.'`, trigger: 'blur' }]">
              <div class="rate">
                <el-input class="styW1" v-model="items.feeAmount"></el-input>
                <div style="margin-left: 6px;">%</div>
                <div style="margin-left: 20px;" class="add_delete_btn" v-if="!dataForm.id && index == dataForm.channelFeeDto.productDatas[1].feeConditionDatas.length - 1" >
                  <img @click="addFee1(items,index)" src="../../../assets/img/add_green.svg" alt="">
                  <i @click="deleteFee1(items,index)" v-if="dataForm.channelFeeDto.productDatas[1].feeConditionDatas.length>1" class="el-icon-delete deleteIcon"></i>
                </div>
              </div>
            </el-form-item>
          </div>
        </div>
      <div class="title">开户费/年费</div>
      <el-form-item class="styW" label="费用" prop="annualFeeDto.feeAmount" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
        <el-input @focus="inputFocus3" @blur="inputBlur3" v-model="dataForm.annualFeeDto.feeAmount" placeholder="￥0.00"></el-input>
      </el-form-item>
      <div class="title">公证费</div>
      <div class="title1">非抵押贷</div>
      <div class="line-box" v-for="(items,index) in dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas" :key= "'non-mortgage-'+index">
        <el-form-item class="sandh1" label="条件" :prop="'notaryFeeDTO.productDatas[0].feeConditionDatas.' + index + '.maxValue'" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }">
          <div class="condition">
            <el-input @input="inputChange2(items,index)" :disabled="items.inputDisabled" class="styW1" v-model="items.minValue" placeholder="￥0.00"></el-input>
            <el-select class="styW2" :disabled="items.selectDisabled" v-model="items.minSymbol"  clearable  placeholder="请选择" >
              <el-option
                v-for="(item,i) in conditionList"
                :key="i"
                :label="item.label"
                :value="item.value"
                >
              </el-option>
            </el-select>
            <div>单笔</div>
            <el-select class="styW2" v-model="items.maxSymbol"  clearable  placeholder="请选择" >
              <el-option
                v-for="(item,i) in conditionList"
                :key="i"
                :label="item.label"
                :value="item.value"
                >
              </el-option>
            </el-select>
            <el-input @input="maxChange2(items,index)" @focus="estimateFocus3(items,index)" @blur="estimateBlur3(items,index)" class="styW1" v-model="items.maxValue" placeholder="￥0.00"></el-input>
          </div>
        </el-form-item>
        <el-form-item  label="费用" :prop="'notaryFeeDTO.productDatas[0].feeConditionDatas.' + index + '.feeAmount'" label-width="60px" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
          <div class="rate">
            <el-input @focus="inputFocus8(items,index)" @blur="inputBlur8(items,index)" class="styW1" v-model="items.feeAmount" placeholder="￥0.00"></el-input>
            <!-- <div style="margin-left: 6px;">%</div> -->
            <div style="margin-left: 20px;" class="add_delete_btn" v-if="!dataForm.id && index == dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas.length - 1" >
              <img @click="addFee2(items,index)" src="../../../assets/img/add_green.svg" alt="">
              <i @click="deleteFee2(items,index)" v-if="dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas.length>1" class="el-icon-delete deleteIcon"></i>
            </div>
          </div>
        </el-form-item>
      </div>
      <div class="title1">抵押贷</div>
      <div class="line-box" v-for="(items,index) in dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas" :key="'mortgage-'+index">
        <el-form-item class="sandh1" label="条件" :prop="'notaryFeeDTO.productDatas[1].feeConditionDatas.' + index + '.maxValue'" :rules="{ required: true, message: $t('validate.required'), trigger: 'blur' }">
          <div class="condition">
            <el-input @input="inputChange3(items,index)" :disabled="items.inputDisabled" class="styW1" v-model="items.minValue" placeholder="￥0.00"></el-input>
            <el-select class="styW2" :disabled="items.selectDisabled" v-model="items.minSymbol"  clearable  placeholder="请选择" >
              <el-option
                v-for="(item,i) in conditionList"
                :key="i"
                :label="item.label"
                :value="item.value"
                >
              </el-option>
            </el-select>
            <div>单笔</div>
            <el-select class="styW2" v-model="items.maxSymbol"  clearable  placeholder="请选择" >
              <el-option
                v-for="(item,i) in conditionList"
                :key="i"
                :label="item.label"
                :value="item.value"
                >
              </el-option>
            </el-select>
            <el-input @input="maxChange3(items,index)" @focus="estimateFocus4(items,index)" @blur="estimateBlur4(items,index)" class="styW1" v-model="items.maxValue" placeholder="￥0.00"></el-input>
          </div>
        </el-form-item>
        <el-form-item  label="费用" :prop="'notaryFeeDTO.productDatas[1].feeConditionDatas.' + index + '.feeAmount'" label-width="60px" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
          <div class="rate">
            <el-input @focus="inputFocus9(items,index)" @blur="inputBlur9(items,index)" class="styW1" v-model="items.feeAmount" placeholder="￥0.00"></el-input>
            <!-- <div style="margin-left: 6px;">%</div> -->
            <div style="margin-left: 20px;" class="add_delete_btn" v-if="!dataForm.id && index == dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas.length - 1">
              <img  @click="addFee3(items,index)" src="../../../assets/img/add_green.svg" alt="">
              <i @click="deleteFee3(items,index)" v-if="dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas.length>1" class="el-icon-delete deleteIcon"></i>
            </div>
          </div>
        </el-form-item>
      </div>
      <div class="title">三方支付费</div>
      <div class="line-box">
        <div>
          <h3 style="margin:10px 44px 20px;">连连支付</h3>
          <el-form-item class="styW" label="充值单笔" prop="paymentGatewayFeeDTO.productFeeDatas[0].feeMoney" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
            <el-input @focus="inputFocus4" @blur="inputBlur4" v-model="dataForm.paymentGatewayFeeDTO.productFeeDatas[0].feeMoney" placeholder="￥0.00"></el-input>
          </el-form-item>
          <el-form-item class="styW" label="放款单笔" prop="paymentGatewayFeeDTO.productFeeDatas[1].feeMoney" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
            <el-input @focus="inputFocus5" @blur="inputBlur5" v-model="dataForm.paymentGatewayFeeDTO.productFeeDatas[1].feeMoney" placeholder="￥0.00"></el-input>
          </el-form-item>
          <el-form-item class="styW" label="提现单笔" prop="paymentGatewayFeeDTO.productFeeDatas[2].feeMoney" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
            <el-input @focus="inputFocus6" @blur="inputBlur6" v-model="dataForm.paymentGatewayFeeDTO.productFeeDatas[2].feeMoney" placeholder="￥0.00"></el-input>
          </el-form-item>
        </div>
        <div>
          <h3 style="margin:10px 44px 20px;">统统付</h3>
          <div class="line-box">
            <el-form-item style="width: 240px;" label="充值费率" prop="paymentGatewayFeeDTO.productFeeDatas[3].feeMoney" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
            <div style="display: flex;">
              <el-input v-model="dataForm.paymentGatewayFeeDTO.productFeeDatas[3].feeMoney" placeholder="0.00"></el-input>
              <span style="padding-left: 8px;">%</span>
            </div>
          </el-form-item>
          <el-form-item label-width="80px" style="width: 180px;" label="上限" prop="paymentGatewayFeeDTO.productFeeDatas[3].amountUpperLimit" >
            <el-input @focus="inputFocus10" @blur="inputBlur10" v-model="dataForm.paymentGatewayFeeDTO.productFeeDatas[3].amountUpperLimit" placeholder="￥0.00"></el-input>
          </el-form-item>
          <el-form-item label-width="80px" style="width: 180px;"  label="下限" prop="paymentGatewayFeeDTO.productFeeDatas[3].amountLowerLimit" >
            <el-input @focus="inputFocus11" @blur="inputBlur11" v-model="dataForm.paymentGatewayFeeDTO.productFeeDatas[3].amountLowerLimit" placeholder="￥0.00"></el-input>
          </el-form-item>
          </div>
          <el-form-item class="styW" label="放款单笔" prop="paymentGatewayFeeDTO.productFeeDatas[4].feeMoney" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
              <el-input @focus="inputFocus12" @blur="inputBlur12" v-model="dataForm.paymentGatewayFeeDTO.productFeeDatas[4].feeMoney" placeholder="0.00"></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="title">电子签章费</div>
      <el-form-item class="styW" label="单笔" prop="esignatureFeeDTO.productFeeDatas[0].feeMoney" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
        <el-input @focus="inputFocus7" @blur="inputBlur7" v-model="dataForm.esignatureFeeDTO.productFeeDatas[0].feeMoney" placeholder="￥0.00"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="qx()">{{ $t('cancel') }}</el-button>
      <el-button :disabled="isConfirm" v-if="type != 'review'" type="primary" @click="dataFormSubmitHandle()">提交复核</el-button>
      <el-button :disabled="isConfirm" v-if="type == 'review'" type="primary" plain @click="examine('reject')">拒绝</el-button>
      <el-button :disabled="isConfirm" v-if="type == 'review'" type="primary" @click="examine('pass')">生效</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { create } from "lodash";
import debounce from "lodash/debounce"
export default {
  data() {
    const validateUpperLimit = (rule, value, callback) => {
  const lowerLimit = this.dataForm.paymentGatewayFeeDTO.productFeeDatas[3].amountLowerLimit.replace(/[^\d.-]/g, '');

  if (value !== null && lowerLimit !== null && parseFloat(value.replace(/[^\d.-]/g, '')) < parseFloat(lowerLimit)) {
    callback(new Error('上限必须大于或等于下限'));
  } else {
    callback();
  }
};

const validateLowerLimit = (rule, value, callback) => {
  const upperLimit = this.dataForm.paymentGatewayFeeDTO.productFeeDatas[3].amountUpperLimit.replace(/[^\d.-]/g, '');

  if (value !== null && upperLimit !== null && parseFloat(value.replace(/[^\d.-]/g, '')) > parseFloat(upperLimit)) {
    callback(new Error('下限必须小于或等于上限'));
  } else {
    callback();
  }
};
    return {
      type:'',
      isConfirm:false,
      disabled:false,
      allDisabled:false,
      loanType:"一刀切",
      loanType1:"一刀切",
      visible: false,
      rules:{},
      fundList: [],
      chargeWayList:[],
      conditionList:[
        {value:'<',label:'<'},
        {value:'<=',label:'<='},
      ],
    
      dataForm: {
        userId: "",     //资金方
        batchId: "",    //批次号
        effectiveDate: this.addDays(new Date(), 1).toISOString().substring(0, 10), //生效日期
        channelFeeDto:{   //通道费
          code: "AISLE_FEE",
          productDatas:[
            {
              chargeWay:"",  //收费方式 dataForm.channelFeeDto.productDatas[0].chargeWay
              feeConditionDatas:[
                {
                  minValue:'0',
                  minSymbol:'<',
                  maxSymbol:'<=',
                  maxValue:'',
                  selectDisabled:true,
                  inputDisabled:true,
                  condition:"",   //条件
                  feeAmount:"",   //费用/费率
                }
              ],
              productCode: "1",  //产品编码
            },
            {
              chargeWay:"",  //收费方式
              feeConditionDatas:[
                {
                  minValue:'0',
                  minSymbol:'<',
                  maxSymbol:'<=',
                  maxValue:'',
                  selectDisabled:true,
                  inputDisabled:true,
                  condition:"",   //条件
                  feeAmount:"",   //费用/费率
                }
              ],
              productCode: "2",  //产品编码
            }
          ]
        },
        annualFeeDto:{    //开户费 dataForm.annualFeeDto.feeAmount
          code: "ACTIVATION_FEE",
          feeAmount: "",
        },
        notaryFeeDTO:{   //公证费 dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas
          code:"NOTARIAL_FEES",
          productDatas:[
            {
              chargeWay:"单笔",  //收费方式
              feeConditionDatas:[
                {
                  minValue:'0',
                  minSymbol:'<',
                  maxSymbol:'<=',
                  maxValue:'',
                  selectDisabled:true,
                  inputDisabled:true,
                  condition:"",   //条件
                  feeAmount:"",   //费用/费率
                }
              ],
              productCode:"1",  //子类编码
            },
            {
              chargeWay:"单笔",  //收费方式
              feeConditionDatas:[
                {
                  minValue:'0',
                  minSymbol:'<',
                  maxSymbol:'<=',
                  maxValue:'',
                  selectDisabled:true,
                  inputDisabled:true,
                  condition:"",   //条件
                  feeAmount:"",   //费用/费率
                }
              ],
              productCode:"2",  //子类编码
            }
          ]
        },
        paymentGatewayFeeDTO:{  //三方支付费 dataForm.paymentGatewayFeeDTO.productFeeDatas[0].feeMoney
          code:"ESCROW_FEE",
          productFeeDatas:[
            {
              chargeWay:"单笔",  //收费方式
              condition:"单笔",   //条件
              feeMoney:"￥20.00",   //产品费用
              productCode:"TOP_UP_SINGLE_FEE",  //子类编码
              payChannelId:0
            },
            {
              chargeWay:"单笔",  //收费方式
              condition:"单笔",   //条件
              feeMoney:"￥2.00",   //产品费用
              productCode:"LOAN_SINGLE_FEE",  //子类编码
              payChannelId:0
            },
            {
              chargeWay:"单笔",  //收费方式
              condition:"单笔",   //条件
              feeMoney:"￥3.00",   //产品费用
              productCode:"WITHDRAW_DEPOSIT_SINGLE_FEE",  //子类编码
              payChannelId:0
            },
            {
              chargeWay:"单笔",  //收费方式
              condition:"单笔",   //条件
              feeMoney:"",   //产品费率
              productCode:"TOP_UP_SINGLE_FEE",  //子类编码
              payChannelId:1,
              amountUpperLimit:"",
              amountLowerLimit:""
            },
            {
              chargeWay:"单笔",  //收费方式
              condition:"单笔",   //条件
              feeMoney:"￥2.00",   //产品费用
              productCode:"LOAN_SINGLE_FEE",  //子类编码
              payChannelId:1
            },
          ]
        },
        
        esignatureFeeDTO:{ //电子签章费 dataForm.esignatureFeeDTO.productFeeDatas[0].feeMoney
          code:"ELECTRONIC_SEAL_FEE",
          productFeeDatas:[
            {
              chargeWay:"单笔",  //收费方式
              condition:"单笔",   //条件
              feeMoney:"￥5.00",   //产品费用
              productCode:"SIGN_AN_AGREEMENT_SINGLE_FEE",  //子类编码
            }
          ]
        },

      },
      pickerOptions: {
        disabledDate(time) {
          // 获取明天的日期
          const tomorrow = new Date();
          tomorrow.setDate(tomorrow.getDate() + 1);
          // 设置时间为当天的开始
          tomorrow.setHours(0, 0, 0, 0);
          time.setHours(0, 0, 0, 0);
          // 只禁用比明天更早的日期
          return time < tomorrow;
        }
      },
      dataRule:{
        userId: [{ required: true, message: this.$t("validate.required"), trigger: "blur" }],
        effectiveDate: [{ required: true, message: this.$t("validate.required"), trigger: "blur" }],
        channelFeeDto : [{ required: true, message: this.$t("validate.required"), trigger: "blur" }],
        'paymentGatewayFeeDTO.productFeeDatas[3].amountUpperLimit': [
          { required: true, message: this.$t('validate.required'), trigger: 'change' },
          { validator: validateUpperLimit, trigger: 'change' }
        ],
        'paymentGatewayFeeDTO.productFeeDatas[3].amountLowerLimit': [
          { required: true, message: this.$t('validate.required'), trigger: 'change' },
          { validator: validateLowerLimit, trigger: 'change' }
        ]
      }
    }
  },
  // computed: {
  //   dataRule() {
  //     return {
        
        
    
  //     }
  //   },
  // },
  created(){
    console.log(23,this.formatting(Number(100000000)));
    this.$http.get('/sys/user/queryUserIdList').then(res=>{
        this.fundList = res.data.data
      })
      this.$http.get(`/sys/dict/data/list?dataType=charge_way`).then(r=>{
        this.chargeWayList = r.data.data ? r.data.data.map(item => ({value:item.dictLabel,label:item.dictLabel})) : []
      })
  },
  mounted() {
      this.restaurants = this.loadAll();
  },
  
  methods: {
    // querySearch(queryString, cb) {
    //     var restaurants = this.restaurants;
    //     var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
    //     // 调用 callback 返回建议列表的数据
    //     cb(results);
    //   },
    //   createFilter(queryString) {
    //     console.log(229,restaurant.value);
        
    //     return (restaurant) => {
    //       return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
    //     };
    //   },
    //   handleSelect(item,index) {

    //   },
      loadAll() {
        return [
          { "value": "30000"},
          { "value": "200000"},
          { "value": "100000000"},

        ];
      },
    // 获取焦点
    inputFocus1(){
      this.dataForm.channelFeeDto.productDatas[0].feeConditionDatas[0].feeAmount = this.dataForm.channelFeeDto.productDatas[0].feeConditionDatas[0].feeAmount.replace(/[^\d.-]/g, '')
    },
    inputBlur1(){
      this.dataForm.channelFeeDto.productDatas[0].feeConditionDatas[0].feeAmount = '￥'+Number(this.dataForm.channelFeeDto.productDatas[0].feeConditionDatas[0].feeAmount).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    inputFocus2(){
      this.dataForm.channelFeeDto.productDatas[1].feeConditionDatas[0].feeAmount = this.dataForm.channelFeeDto.productDatas[1].feeConditionDatas[0].feeAmount.replace(/[^\d.-]/g, '')
    },
    inputBlur2(){
      this.dataForm.channelFeeDto.productDatas[1].feeConditionDatas[0].feeAmount = '￥'+Number(this.dataForm.channelFeeDto.productDatas[1].feeConditionDatas[0].feeAmount).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    inputFocus3(){
      this.dataForm.annualFeeDto.feeAmount = this.dataForm.annualFeeDto.feeAmount.replace(/[^\d.-]/g, '')
    },
    inputBlur3(){
      if(isNaN(Number(this.dataForm.annualFeeDto.feeAmount))){
        return this.$message.error('请输入数字或"."')
      }
      this.dataForm.annualFeeDto.feeAmount = '￥'+Number(this.dataForm.annualFeeDto.feeAmount).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    inputFocus4(){
      this.dataForm.paymentGatewayFeeDTO.productFeeDatas[0].feeMoney = this.dataForm.paymentGatewayFeeDTO.productFeeDatas[0].feeMoney.replace(/[^\d.-]/g, '')
    },
    inputBlur4(){
      if(isNaN(Number(this.dataForm.paymentGatewayFeeDTO.productFeeDatas[0].feeMoney))){
        return this.$message.error('请输入数字或"."')
      }
      this.dataForm.paymentGatewayFeeDTO.productFeeDatas[0].feeMoney = '￥'+Number(this.dataForm.paymentGatewayFeeDTO.productFeeDatas[0].feeMoney).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    inputFocus5(){
      this.dataForm.paymentGatewayFeeDTO.productFeeDatas[1].feeMoney = this.dataForm.paymentGatewayFeeDTO.productFeeDatas[1].feeMoney.replace(/[^\d.-]/g, '')
    },
    inputBlur5(){
      if(isNaN(Number(this.dataForm.paymentGatewayFeeDTO.productFeeDatas[1].feeMoney))){
        return this.$message.error('请输入数字或"."')
      }
      this.dataForm.paymentGatewayFeeDTO.productFeeDatas[1].feeMoney = '￥'+Number(this.dataForm.paymentGatewayFeeDTO.productFeeDatas[1].feeMoney).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    inputFocus6(){
      this.dataForm.paymentGatewayFeeDTO.productFeeDatas[2].feeMoney = this.dataForm.paymentGatewayFeeDTO.productFeeDatas[2].feeMoney.replace(/[^\d.-]/g, '')
    },
    inputBlur6(){
      if(isNaN(Number(this.dataForm.paymentGatewayFeeDTO.productFeeDatas[2].feeMoney))){
        return this.$message.error('请输入数字或"."')
      }
      this.dataForm.paymentGatewayFeeDTO.productFeeDatas[2].feeMoney = '￥'+Number(this.dataForm.paymentGatewayFeeDTO.productFeeDatas[2].feeMoney).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    inputFocus7(){
      this.dataForm.esignatureFeeDTO.productFeeDatas[0].feeMoney = this.dataForm.esignatureFeeDTO.productFeeDatas[0].feeMoney.replace(/[^\d.-]/g, '')
    },
    inputBlur7(){
      if(isNaN(Number(this.dataForm.esignatureFeeDTO.productFeeDatas[0].feeMoney))){
        return this.$message.error('请输入数字或"."')
      }
      this.dataForm.esignatureFeeDTO.productFeeDatas[0].feeMoney = '￥'+Number(this.dataForm.esignatureFeeDTO.productFeeDatas[0].feeMoney).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    inputFocus8(item,index){
      this.dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas[index].feeAmount = this.dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas[index].feeAmount.replace(/[^\d.-]/g, '')
    },
    inputBlur8(item,index){
      this.dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas[index].feeAmount = '￥'+Number(this.dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas[index].feeAmount).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    inputFocus9(item,index){
      this.dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas[index].feeAmount = this.dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas[index].feeAmount.replace(/[^\d.-]/g, '')
    },
    inputBlur9(item,index){
      this.dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas[index].feeAmount = '￥'+Number(this.dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas[index].feeAmount).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    inputFocus10(){
      this.dataForm.paymentGatewayFeeDTO.productFeeDatas[3].amountUpperLimit = this.dataForm.paymentGatewayFeeDTO.productFeeDatas[3].amountUpperLimit.replace(/[^\d.-]/g, '')
    },
    inputBlur10(){
      if(isNaN(Number(this.dataForm.paymentGatewayFeeDTO.productFeeDatas[3].amountUpperLimit))){
        return this.$message.error('请输入数字或"."')
      }
      this.dataForm.paymentGatewayFeeDTO.productFeeDatas[3].amountUpperLimit = '￥'+Number(this.dataForm.paymentGatewayFeeDTO.productFeeDatas[3].amountUpperLimit).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })
      
    },
    inputFocus11(){
      this.dataForm.paymentGatewayFeeDTO.productFeeDatas[3].amountLowerLimit = this.dataForm.paymentGatewayFeeDTO.productFeeDatas[3].amountLowerLimit.replace(/[^\d.-]/g, '')
    },
    inputBlur11(){
      if(isNaN(Number(this.dataForm.paymentGatewayFeeDTO.productFeeDatas[3].amountLowerLimit))){
        return this.$message.error('请输入数字或"."')
      }
      this.dataForm.paymentGatewayFeeDTO.productFeeDatas[3].amountLowerLimit = '￥'+Number(this.dataForm.paymentGatewayFeeDTO.productFeeDatas[3].amountLowerLimit).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    inputFocus12(){
      this.dataForm.paymentGatewayFeeDTO.productFeeDatas[4].feeMoney = this.dataForm.paymentGatewayFeeDTO.productFeeDatas[4].feeMoney.replace(/[^\d.-]/g, '')
    },
    inputBlur12(){
      if(isNaN(Number(this.dataForm.paymentGatewayFeeDTO.productFeeDatas[4].feeMoney))){
        return this.$message.error('请输入数字或"."')
      }
      this.dataForm.paymentGatewayFeeDTO.productFeeDatas[4].feeMoney = '￥'+Number(this.dataForm.paymentGatewayFeeDTO.productFeeDatas[4].feeMoney).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    // 输入值改变
    inputChange(e,index){
      if( e.minValue && e.minValue == '0'){
        this.dataForm.channelFeeDto.productDatas[0].feeConditionDatas[index].selectDisabled = true
        this.dataForm.channelFeeDto.productDatas[0].feeConditionDatas[index].minSymbol = '<'
      }else{
        this.dataForm.channelFeeDto.productDatas[0].feeConditionDatas[index].selectDisabled = false
      }
    },
    inputChange1(e,index){
      if( e.minValue && e.minValue == '0'){
        this.dataForm.channelFeeDto.productDatas[1].feeConditionDatas[index].selectDisabled = true
        this.dataForm.channelFeeDto.productDatas[1].feeConditionDatas[index].minSymbol = '<'
      }else{
        this.dataForm.channelFeeDto.productDatas[1].feeConditionDatas[index].selectDisabled = false
      }
    },
    inputChange2(e,index){
      if( e.minValue && e.minValue == '0'){
        this.dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas[index].selectDisabled = true
        this.dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas[index].minSymbol = '<'
      }else{
        this.dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas[index].selectDisabled = false
      }
    },
    inputChange3(e,index){
      if( e.minValue && e.minValue == '0'){
        this.dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas[index].selectDisabled = true
        this.dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas[index].minSymbol = '<'
      }else{
        this.dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas[index].selectDisabled = false
      }
    },
    // 最大值改变
    maxChange(item,index){
        if(this.dataForm.channelFeeDto.productDatas[0].feeConditionDatas[index+1]){
          this.dataForm.channelFeeDto.productDatas[0].feeConditionDatas[index+1].minValue = this.formatting(Number(item.maxValue))
        }       
    },
    maxChange1(item,index){
      if(this.dataForm.channelFeeDto.productDatas[1].feeConditionDatas[index+1]){
        this.dataForm.channelFeeDto.productDatas[1].feeConditionDatas[index+1].minValue = this.formatting(Number(item.maxValue))
      }   
    },
    maxChange2(item,index){
      if(this.dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas[index+1]){
        this.dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas[index+1].minValue = this.formatting(Number(item.maxValue))
      }
    },
    maxChange3(item,index){
      if(this.dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas[index+1]){
        this.dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas[index+1].minValue = this.formatting(Number(item.maxValue))
      }
        
    },
    // 输入最大值后判断
    
    estimateBlur1(item,index){
      if(isNaN(this.dataForm.channelFeeDto.productDatas[0].feeConditionDatas[index].maxValue)){
        return this.$message.error('请输入数字或"."')
      }
      this.dataForm.channelFeeDto.productDatas[0].feeConditionDatas[index].maxValue = this.formatting(Math.round(Number( this.dataForm.channelFeeDto.productDatas[0].feeConditionDatas[index].maxValue)))
      if(Number(this.parseFormatting(item.minValue)) > Number(this.parseFormatting(item.maxValue)) || Number(this.parseFormatting(item.minValue)) == Number(this.parseFormatting(item.maxValue))){
        this.$message.error('最小值不能大于或等于最大值')
        return
      }
    },
    estimateFocus1(item,index){
      if(this.dataForm.channelFeeDto.productDatas[0].feeConditionDatas[index].maxValue){
        this.dataForm.channelFeeDto.productDatas[0].feeConditionDatas[index].maxValue = this.parseFormatting(this.dataForm.channelFeeDto.productDatas[0].feeConditionDatas[index].maxValue)
      }     
    },
    estimateBlur2(item,index){
      if(isNaN(this.dataForm.channelFeeDto.productDatas[1].feeConditionDatas[index].maxValue)){
        return this.$message.error('请输入数字或"."')
      }
      this.dataForm.channelFeeDto.productDatas[1].feeConditionDatas[index].maxValue = this.formatting(Math.round(Number( this.dataForm.channelFeeDto.productDatas[1].feeConditionDatas[index].maxValue)))
      if(Number(this.parseFormatting(item.minValue)) > Number(this.parseFormatting(item.maxValue)) || Number(this.parseFormatting(item.minValue)) == Number(this.parseFormatting(item.maxValue))){
        this.$message.error('最小值不能大于或等于最大值')
        return
      }
    },
    estimateFocus2(item,index){
      if(this.dataForm.channelFeeDto.productDatas[1].feeConditionDatas[index].maxValue){
        this.dataForm.channelFeeDto.productDatas[1].feeConditionDatas[index].maxValue = this.parseFormatting(this.dataForm.channelFeeDto.productDatas[1].feeConditionDatas[index].maxValue)
      }     
    },
    estimateBlur3(item,index){
      if(isNaN(this.dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas[index].maxValue)){
        return this.$message.error('请输入数字或"."')
      }
      this.dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas[index].maxValue = this.formatting(Math.round(Number( this.dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas[index].maxValue)))
      if(Number(this.parseFormatting(item.minValue)) > Number(this.parseFormatting(item.maxValue)) || Number(this.parseFormatting(item.minValue)) == Number(this.parseFormatting(item.maxValue))){
        this.$message.error('最小值不能大于或等于最大值')
        return
      }
    },
    estimateFocus3(item,index){
      if(this.dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas[index].maxValue){
        this.dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas[index].maxValue = this.parseFormatting(this.dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas[index].maxValue)
      }     
    },
    estimateBlur4(item,index){
      if(isNaN(this.dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas[index].maxValue)){
        return this.$message.error('请输入数字或"."')
      }
      this.dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas[index].maxValue = this.formatting(Math.round(Number( this.dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas[index].maxValue)))
      if(Number(this.parseFormatting(item.minValue)) > Number(this.parseFormatting(item.maxValue)) || Number(this.parseFormatting(item.minValue)) == Number(this.parseFormatting(item.maxValue))){
        this.$message.error('最小值不能大于或等于最大值')
        return
      }
    },
    estimateFocus4(item,index){
      if(this.dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas[index].maxValue){
        this.dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas[index].maxValue = this.parseFormatting(this.dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas[index].maxValue)
      }     
    },
    
    // 非抵押贷收费方式改变
    changeChargeWay(e){
      this.dataForm.channelFeeDto.productDatas[0].feeConditionDatas = [{
        minValue:'0',
        minSymbol:'<',
        maxSymbol:'<=',
        maxValue:'',
        selectDisabled:true,
        inputDisabled:true,
        condition:"",   //条件
        feeAmount:"",   //费用/费率
        }]
      if(e == '按单笔额度'){
        this.loanType = '单笔'
      }else if(e == '按月放款量'){
        this.loanType = '月放款量'
      }else{
        this.loanType = '一刀切'
      }
    },
    // 抵押贷收费方式改变
    changeChargeWay1(e){
      this.dataForm.channelFeeDto.productDatas[1].feeConditionDatas = [{
        minValue:'0',
        minSymbol:'<',
        maxSymbol:'<=',
        maxValue:'',
        selectDisabled:true,
        inputDisabled:true,
        condition:"",   //条件
        feeAmount:"",   //费用/费率
      }]
      if(e == '按单笔额度'){
        this.loanType1 = '单笔'
      }else if(e == '按月放款量'){
        this.loanType1 = '月放款量'
      }else{
        this.loanType1 = '一刀切'
      }
    },
    addFee(item,index){
      if(item.maxValue == '' || item.minValue == '' || item.feeAmount == '' || item.minSymbol == '' || item.maxSymbol == ''){
        this.$message.error('请先完善条件再添加')
        return
      }
      console.log(111,item.minValue,item.maxValue);
      if(Number(this.parseFormatting(item.minValue)) > Number(this.parseFormatting(item.maxValue)) || Number(this.parseFormatting(item.minValue)) == Number(this.parseFormatting(item.maxValue))){
        this.$message.error('最小值不能大于或等于最大值')
        return
      }
      this.dataForm.channelFeeDto.productDatas[0].feeConditionDatas.push({
          minValue:'',
          minSymbol:'',
          maxSymbol:'<=',
          maxValue:'',
          feeAmount:'',
        })
      this.dataForm.channelFeeDto.productDatas[0].feeConditionDatas[index+1].inputDisabled = true
      this.dataForm.channelFeeDto.productDatas[0].feeConditionDatas[index+1].selectDisabled = true
      this.dataForm.channelFeeDto.productDatas[0].feeConditionDatas[index+1].minValue = this.dataForm.channelFeeDto.productDatas[0].feeConditionDatas[index].maxValue
      if(this.dataForm.channelFeeDto.productDatas[0].feeConditionDatas[index].maxSymbol == '<='){
        this.dataForm.channelFeeDto.productDatas[0].feeConditionDatas[index+1].minSymbol = '<'
      }else{
        this.dataForm.channelFeeDto.productDatas[0].feeConditionDatas[index+1].minSymbol = '<='
      }
    },
    addFee1(item,index){
      if(item.maxValue == '' || item.minValue == '' || item.feeAmount == '' || item.minSymbol == '' || item.maxSymbol == ''){
        this.$message.error('请先完善条件再添加')
        return
      }
      if(Number(this.parseFormatting(item.minValue)) > Number(this.parseFormatting(item.maxValue)) || Number(this.parseFormatting(item.minValue)) == Number(this.parseFormatting(item.maxValue))){
        this.$message.error('最小值不能大于或等于最大值')
        return
      }
      this.dataForm.channelFeeDto.productDatas[1].feeConditionDatas.push({
          minValue:'',
          minSymbol:'',
          maxSymbol:'<=',
          maxValue:'',
          feeAmount:'',
        })
      this.dataForm.channelFeeDto.productDatas[1].feeConditionDatas[index+1].inputDisabled = true
      this.dataForm.channelFeeDto.productDatas[1].feeConditionDatas[index+1].selectDisabled = true
      this.dataForm.channelFeeDto.productDatas[1].feeConditionDatas[index+1].minValue = this.dataForm.channelFeeDto.productDatas[1].feeConditionDatas[index].maxValue
      if(this.dataForm.channelFeeDto.productDatas[1].feeConditionDatas[index].maxSymbol == '<='){
        this.dataForm.channelFeeDto.productDatas[1].feeConditionDatas[index+1].minSymbol = '<'
      }else{
        this.dataForm.channelFeeDto.productDatas[1].feeConditionDatas[index+1].minSymbol = '<='
      }
    },
    addFee2(item,index){
      if(item.maxValue == '' || item.minValue == '' || item.feeAmount == '' || item.minSymbol == '' || item.maxSymbol == ''){
        this.$message.error('请先完善条件再添加')
        return
      }
      if(Number(this.parseFormatting(item.minValue)) > Number(this.parseFormatting(item.maxValue)) || Number(this.parseFormatting(item.minValue)) == Number(this.parseFormatting(item.maxValue))){
        this.$message.error('最小值不能大于或等于最大值')
        return
      }
      this.dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas.push({
          minValue:'',
          minSymbol:'',
          maxSymbol:'<=',
          maxValue:'',
          feeAmount:'',
        })
      this.dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas[index+1].inputDisabled = true
      this.dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas[index+1].selectDisabled = true
      this.dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas[index+1].minValue = this.dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas[index].maxValue
      if(this.dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas[index].maxSymbol == '<='){
        this.dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas[index+1].minSymbol = '<'
      }else{
        this.dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas[index+1].minSymbol = '<='
      }
    },
    addFee3(item,index){
      if(item.maxValue == '' || item.minValue == '' || item.feeAmount == '' || item.minSymbol == '' || item.maxSymbol == ''){
        this.$message.error('请先完善条件再添加')
        return
      }
      if(Number(this.parseFormatting(item.minValue)) > Number(this.parseFormatting(item.maxValue)) || Number(this.parseFormatting(item.minValue)) == Number(this.parseFormatting(item.maxValue))){
        this.$message.error('最小值不能大于或等于最大值')
        return
      }
      this.dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas.push({
          minValue:'',
          minSymbol:'',
          maxSymbol:'<=',
          maxValue:'',
          feeAmount:'',
        })
      this.dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas[index+1].inputDisabled = true
      this.dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas[index+1].selectDisabled = true
      this.dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas[index+1].minValue = this.dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas[index].maxValue
      if(this.dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas[index].maxSymbol == '<='){
        this.dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas[index+1].minSymbol = '<'
      }else{
        this.dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas[index+1].minSymbol = '<='
      }
    },
    // 删除数组最后一个元素
    deleteFee(item,index){
      this.dataForm.channelFeeDto.productDatas[0].feeConditionDatas.pop()
    },
    deleteFee1(item,index){
      this.dataForm.channelFeeDto.productDatas[1].feeConditionDatas.pop()
    },
    deleteFee2(item,index){
      this.dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas.pop()
    },
    deleteFee3(item,index){
      this.dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas.pop()
    },
    addDays(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    },
    // 检查是否首次录入
    checkoutFirst(e,type,batchId){
      this.$http.get(`/system/serviceFees/checkout?batchId=${batchId}&type=${type}&userId=${e}`).then(res=>{
        console.log(122,res.data);
        if(res.data.data == false){
          
          this.disabled = true
          if(this.type == 'review'){
            return
          }
          this.dataForm.effectiveDate = new Date().toISOString().substring(0, 10)
        }else{
          this.disabled = false
          if(this.type == 'review'){
            return
          }
          this.dataForm.effectiveDate = this.addDays(new Date(), 1).toISOString().substring(0, 10)
        }
      })
    },
    changeFund(e){
      if(this.dataForm.id){
        this.checkoutFirst(e,'update',this.dataForm.id)
      }else{
        this.checkoutFirst(e,'save','')
      }

    },
    
    init() {
      this.visible = true
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
          
        }
        if(this.type == 'review'){
          this.allDisabled = true
        }else{
          this.allDisabled = false
        }
      })
    },
    // 获取信息
    getInfo() {
      this.$http
        .get(`/system/serviceFees/info/${this.dataForm.id}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          console.log(222,res.data);
          this.checkoutFirst(res.data.userId,'update',this.dataForm.id)
          this.dataForm = {
            ...this.dataForm,
            ...res.data,
          }
          if(this.type == 'review'){
            this.dataForm.effectiveDate = res.data.effectiveDate
            console.log(222,this.dataForm.effectiveDate);
          }
          this.dataForm.channelFeeDto.productDatas[0].feeConditionDatas.map(item=>{
            item.inputDisabled = true
            item.selectDisabled = true
          })
          this.dataForm.channelFeeDto.productDatas[1].feeConditionDatas.map(item=>{
            item.inputDisabled = true
            item.selectDisabled = true
          })
          this.dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas.map(item=>{
            item.inputDisabled = true
            item.selectDisabled = true
          })
          this.dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas.map(item=>{
            item.inputDisabled = true
            item.selectDisabled = true
          })
          if(this.dataForm.channelFeeDto.productDatas[0].chargeWay == '按单笔额度'){
            this.loanType = '单笔'
          }else if(this.dataForm.channelFeeDto.productDatas[0].chargeWay == '按月放款量'){
            this.loanType = '月放款量'
          }else{
            this.loanType = '一刀切'
          }
          if(this.dataForm.channelFeeDto.productDatas[1].chargeWay == '按单笔额度'){
            this.loanType1 = '单笔'
          }else if(this.dataForm.channelFeeDto.productDatas[1].chargeWay == '按月放款量'){
            this.loanType1 = '月放款量'
          }else{
            this.loanType1 = '一刀切'
          }

         this.dataForm.channelFeeDto.productDatas[0].feeConditionDatas.map(item => {
            let parts = item.condition.split(/(<(?:=)?)/g).filter(Boolean);
            this.$set(item, 'minValue', parts[0]);
            this.$set(item, 'minSymbol', parts[1]);
            this.$set(item, 'maxSymbol', parts[3]);
            this.$set(item, 'maxValue', parts[4]);
          })
          this.dataForm.channelFeeDto.productDatas[1].feeConditionDatas.map(item => {
            let parts = item.condition.split(/(<(?:=)?)/g).filter(Boolean);
            this.$set(item, 'minValue', parts[0]);
            this.$set(item, 'minSymbol', parts[1]);
            this.$set(item, 'maxSymbol', parts[3]);
            this.$set(item, 'maxValue', parts[4]);
          })
          this.dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas.map(item => {
            let parts = item.condition.split(/(<(?:=)?)/g).filter(Boolean);
            this.$set(item, 'minValue', parts[0]);
            this.$set(item, 'minSymbol', parts[1]);
            this.$set(item, 'maxSymbol', parts[3]);
            this.$set(item, 'maxValue', parts[4]);
            this.$set(item, 'feeAmount', '￥'+Number(item.feeAmount).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 }));
          })
          this.dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas.map(item => {
            let parts = item.condition.split(/(<(?:=)?)/g).filter(Boolean);
            this.$set(item, 'minValue', parts[0]);
            this.$set(item, 'minSymbol', parts[1]);
            this.$set(item, 'maxSymbol', parts[3]);
            this.$set(item, 'maxValue', parts[4]);
            this.$set(item, 'feeAmount', '￥'+Number(item.feeAmount).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 }));
          })
          console.log(434,this.dataForm);
          // if(this.dataForm.channelFeeDto.productDatas[0].chargeWay == '一刀切'){
          //   this.dataForm.channelFeeDto.productDatas[0].feeConditionDatas[0].feeAmount = '￥'+Number(this.dataForm.channelFeeDto.productDatas[0].feeConditionDatas[0].feeAmount).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })
          // }
          // if(this.dataForm.channelFeeDto.productDatas[1].chargeWay == '一刀切'){
          //   this.dataForm.channelFeeDto.productDatas[1].feeConditionDatas[0].feeAmount = '￥'+Number(this.dataForm.channelFeeDto.productDatas[1].feeConditionDatas[0].feeAmount).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })
          // }
          
          this.dataForm.annualFeeDto.feeAmount = '￥'+Number(this.dataForm.annualFeeDto.feeAmount).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })
          this.dataForm.paymentGatewayFeeDTO.productFeeDatas[0].feeMoney = '￥'+Number(this.dataForm.paymentGatewayFeeDTO.productFeeDatas[0].feeMoney).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })
          this.dataForm.paymentGatewayFeeDTO.productFeeDatas[1].feeMoney = '￥'+Number(this.dataForm.paymentGatewayFeeDTO.productFeeDatas[1].feeMoney).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })
          this.dataForm.paymentGatewayFeeDTO.productFeeDatas[2].feeMoney = '￥'+Number(this.dataForm.paymentGatewayFeeDTO.productFeeDatas[2].feeMoney).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })
          this.dataForm.paymentGatewayFeeDTO.productFeeDatas[4].feeMoney = '￥'+Number(this.dataForm.paymentGatewayFeeDTO.productFeeDatas[4].feeMoney).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })
          this.dataForm.paymentGatewayFeeDTO.productFeeDatas[3].amountLowerLimit = '￥'+Number(this.dataForm.paymentGatewayFeeDTO.productFeeDatas[3].amountLowerLimit).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })
          this.dataForm.paymentGatewayFeeDTO.productFeeDatas[3].amountUpperLimit = '￥'+Number(this.dataForm.paymentGatewayFeeDTO.productFeeDatas[3].amountUpperLimit).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })
          this.dataForm.esignatureFeeDTO.productFeeDatas[0].feeMoney = '￥'+Number(this.dataForm.esignatureFeeDTO.productFeeDatas[0].feeMoney).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })
        })
        .catch(() => {})
    },
    deepCopy(obj) {
      if (obj === null || typeof obj !== 'object') {
        return obj;
      }
      let copy = Array.isArray(obj) ? [] : {};
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) { // 确保只复制对象自身的属性，而不是原型链上的属性
          copy[key] = this.deepCopy(obj[key]); // 递归调用深拷贝函数，以确保内部对象也被复制
        }
      }
  
      return copy; // 返回完全独立的副本
    },
    // 金额转化
    formatting(number){
      if (number < 10000) {
        return number.toString(); // 如果小于10000，直接返回原始数字的字符串形式
      }
      let units = ["", "万", "亿"]; // 单位数组，每四位对应一个单位
      let digit = Math.floor(Math.log10(number)); // 获取数字的位数
      let unitIndex = Math.floor(digit / 4); // 确定位数对应的单位索引
      let result = number / Math.pow(10, unitIndex * 4); // 计算数字除以对应单位的幂次方
      return result + units[unitIndex]; // 返回结果保留两位小数，并附上单位
    },
    parseFormatting(amountStr){
      let amount = parseFloat(amountStr.replace(/[^\d.-]/g, ''));

      // 根据单位字符调整数值
      if (amountStr.includes("万")) {
        amount *= 10000;
      } else if (amountStr.includes("亿")) {
        amount *= 100000000;
      }
      return amount;
    },
    qx(){
      this.visible = false
      this.dataForm ={
        userId: "",     //资金方
        batchId: "",    //批次号
        effectiveDate: this.addDays(new Date(), 1).toISOString().substring(0, 10), //生效日期
        channelFeeDto:{   //通道费
          code: "AISLE_FEE",
          productDatas:[
            {
              chargeWay:"",  //收费方式 
              feeConditionDatas:[
                {
                  minValue:'0',
                  minSymbol:'<',
                  maxSymbol:'<=',
                  maxValue:'',
                  selectDisabled:true,
                  inputDisabled:true,
                  condition:"",   //条件
                  feeAmount:"",   //费用/费率
                }
              ],
              productCode: "1",  //产品编码
            },
            {
              chargeWay:"",  //收费方式
              feeConditionDatas:[
                {
                  minValue:'0',
                  minSymbol:'<',
                  maxSymbol:'<=',
                  maxValue:'',
                  selectDisabled:true,
                  inputDisabled:true,
                  condition:"",   //条件
                  feeAmount:"",   //费用/费率
                }
              ],
              productCode: "2",  //产品编码
            }
          ]
        },
        annualFeeDto:{    //开户费
          code: "ACTIVATION_FEE",
          feeAmount: "",
        },
        notaryFeeDTO:{   //公证费 
          code:"NOTARIAL_FEES",
          productDatas:[
            {
              chargeWay:"单笔",  //收费方式
              feeConditionDatas:[
                {
                  minValue:'0',
                  minSymbol:'<',
                  maxSymbol:'<=',
                  maxValue:'',
                  selectDisabled:true,
                  inputDisabled:true,
                  condition:"",   //条件
                  feeAmount:"",   //费用/费率
                }
              ],
              productCode:"1",  //子类编码
            },
            {
              chargeWay:"单笔",  //收费方式
              feeConditionDatas:[
                {
                  minValue:'0',
                  minSymbol:'<',
                  maxSymbol:'<=',
                  maxValue:'',
                  selectDisabled:true,
                  inputDisabled:true,
                  condition:"",   //条件
                  feeAmount:"",   //费用/费率
                }
              ],
              productCode:"2",  //子类编码
            }
          ]
        },
        paymentGatewayFeeDTO:{  //三方支付费 
          code:"ESCROW_FEE",
          productFeeDatas:[
            {
              chargeWay:"单笔",  //收费方式
              condition:"单笔",   //条件
              feeMoney:"￥20.00",   //产品费用
              productCode:"TOP_UP_SINGLE_FEE",  //子类编码
            },
            {
              chargeWay:"单笔",  //收费方式
              condition:"单笔",   //条件
              feeMoney:"￥2.00",   //产品费用
              productCode:"LOAN_SINGLE_FEE",  //子类编码
            },
            {
              chargeWay:"单笔",  //收费方式
              condition:"单笔",   //条件
              feeMoney:"￥3.00",   //产品费用
              productCode:"WITHDRAW_DEPOSIT_SINGLE_FEE",  //子类编码
            },
            {
              chargeWay:"单笔",  //收费方式
              condition:"单笔",   //条件
              feeMoney:"",   //产品费率
              productCode:"TOP_UP_SINGLE_FEE",  //子类编码
              payChannelId:1,
              amountUpperLimit:"",
              amountLowerLimit:""
            },
            {
              chargeWay:"单笔",  //收费方式
              condition:"单笔",   //条件
              feeMoney:"",   //产品费用
              productCode:"LOAN_SINGLE_FEE",  //子类编码
              payChannelId:1
            },
          ]
        },       
        esignatureFeeDTO:{ //电子签章费 dataForm.esignatureFeeDTO.productFeeDatas[0].feeMoney
          code:"ELECTRONIC_SEAL_FEE",
          productFeeDatas:[
            {
              chargeWay:"单笔",  //收费方式
              condition:"单笔",   //条件
              feeMoney:"￥5.00",   //产品费用
              productCode:"SIGN_AN_AGREEMENT_SINGLE_FEE",  //子类编码
            }
          ]
        },

      }
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function () {
        this.$refs["dataForm"].validate((valid) => {
          if (!valid) {
            return false
          }
          console.log(24,this.dataForm);
          console.log(25,this.dataForm.channelFeeDto.productDatas[0].feeConditionDatas);
          if(this.dataForm.channelFeeDto.productDatas[0].chargeWay != '一刀切'){
            console.log(1);
            if(this.dataForm.channelFeeDto.productDatas[0].feeConditionDatas[0].minValue != '0' || this.dataForm.channelFeeDto.productDatas[0].feeConditionDatas[this.dataForm.channelFeeDto.productDatas[0].feeConditionDatas.length - 1].maxValue != '1亿'){
              this.$message.error('条件未覆盖(0,1亿),存在未设置的范围，请设置完成再提交')
              return
            }
          }
          if(this.dataForm.channelFeeDto.productDatas[1].chargeWay != '一刀切'){
            console.log(2);
            if(this.dataForm.channelFeeDto.productDatas[1].feeConditionDatas[0].minValue != '0' || this.dataForm.channelFeeDto.productDatas[1].feeConditionDatas[this.dataForm.channelFeeDto.productDatas[1].feeConditionDatas.length - 1].maxValue != '1亿'){
              this.$message.error('条件未覆盖(0,1亿),存在未设置的范围，请设置完成再提交')
              return
            }
          }
          if(this.dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas[0].minValue != '0' || this.dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas[this.dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas.length - 1].maxValue != '1亿'){
            this.$message.error('条件未覆盖(0,1亿),存在未设置的范围，请设置完成再提交')
            return
          }
          if(this.dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas[0].minValue != '0' || this.dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas[this.dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas.length - 1].maxValue != '1亿'){
            this.$message.error('条件未覆盖(0,1亿),存在未设置的范围，请设置完成再提交')
              return
          }
          
          
          let dataForm = this.deepCopy(this.dataForm);

          // dataForm.channelFeeDto.productDatas[0].feeConditionDatas[0].feeAmount = dataForm.channelFeeDto.productDatas[0].feeConditionDatas[0].feeAmount.replace(/[^\d.-]/g, '')
          // dataForm.channelFeeDto.productDatas[1].feeConditionDatas[0].feeAmount = dataForm.channelFeeDto.productDatas[1].feeConditionDatas[0].feeAmount.replace(/[^\d.-]/g, '')
          dataForm.annualFeeDto.feeAmount = dataForm.annualFeeDto.feeAmount.replace(/[^\d.-]/g, '')
          dataForm.paymentGatewayFeeDTO.productFeeDatas[0].feeMoney = dataForm.paymentGatewayFeeDTO.productFeeDatas[0].feeMoney.replace(/[^\d.-]/g, '')
          dataForm.paymentGatewayFeeDTO.productFeeDatas[1].feeMoney = dataForm.paymentGatewayFeeDTO.productFeeDatas[1].feeMoney.replace(/[^\d.-]/g, '')
          dataForm.paymentGatewayFeeDTO.productFeeDatas[2].feeMoney = dataForm.paymentGatewayFeeDTO.productFeeDatas[2].feeMoney.replace(/[^\d.-]/g, '')
          dataForm.paymentGatewayFeeDTO.productFeeDatas[4].feeMoney = dataForm.paymentGatewayFeeDTO.productFeeDatas[4].feeMoney.replace(/[^\d.-]/g, '')
          dataForm.paymentGatewayFeeDTO.productFeeDatas[3].amountLowerLimit = dataForm.paymentGatewayFeeDTO.productFeeDatas[3].amountLowerLimit.replace(/[^\d.-]/g, '')
          dataForm.paymentGatewayFeeDTO.productFeeDatas[3].amountUpperLimit = dataForm.paymentGatewayFeeDTO.productFeeDatas[3].amountUpperLimit.replace(/[^\d.-]/g, '')
          dataForm.esignatureFeeDTO.productFeeDatas[0].feeMoney = dataForm.esignatureFeeDTO.productFeeDatas[0].feeMoney.replace(/[^\d.-]/g, '')
          
          dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas.map((item,index)=>{
            item.feeAmount = item.feeAmount.replace(/[^\d.-]/g, '')
          })
          dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas.map((item,index)=>{
            item.feeAmount = item.feeAmount.replace(/[^\d.-]/g, '')
          })
          console.log(78,this.loanType,this.loanType1);
          dataForm.channelFeeDto.productDatas[0].feeConditionDatas = dataForm.channelFeeDto.productDatas[0].feeConditionDatas.map((item,index)=>{
            if(this.loanType == '一刀切'){
              item.condition = '单笔'
            }else{
              
              item.condition = item.minValue + item.minSymbol + this.loanType + item.maxSymbol + item.maxValue
            }      
            const { minValue, maxValue,minSymbol, maxSymbol,selectDisabled,inputDisabled, ...rest } = item;
            return rest
          })
         dataForm.channelFeeDto.productDatas[1].feeConditionDatas = dataForm.channelFeeDto.productDatas[1].feeConditionDatas.map((item,index)=>{
          if(this.loanType1 == '一刀切'){
            item.condition = '单笔'
          }else{
           
            item.condition = item.minValue + item.minSymbol + this.loanType1 + item.maxSymbol + item.maxValue
          }
            const { minValue, maxValue,minSymbol, maxSymbol,selectDisabled,inputDisabled, ...rest } = item;
            return rest
          })
          dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas = dataForm.notaryFeeDTO.productDatas[0].feeConditionDatas.map((item,index)=>{
           
            item.condition = item.minValue + item.minSymbol + '单笔' + item.maxSymbol + item.maxValue
            const { minValue, maxValue,minSymbol, maxSymbol,selectDisabled,inputDisabled, ...rest } = item;
            return rest
          })
          dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas = dataForm.notaryFeeDTO.productDatas[1].feeConditionDatas.map((item,index)=>{
           
            item.condition = item.minValue + item.minSymbol + '单笔' + item.maxSymbol + item.maxValue
            const { minValue, maxValue,minSymbol, maxSymbol,selectDisabled,inputDisabled, ...rest } = item;
            return rest
          })
          
          if(dataForm.notaryFeeDTO.productDatas[0].chargeWay == ''){
            dataForm.notaryFeeDTO.productDatas[0].chargeWay = '单笔'
          }
          if(dataForm.notaryFeeDTO.productDatas[1].chargeWay == ''){
            dataForm.notaryFeeDTO.productDatas[1].chargeWay = '单笔'
          }
          
          this.isConfirm = true
          this.$http[!this.dataForm.id ? "post" : "put"](`system/serviceFees/${!this.dataForm.id ? "save" : "update"}`, dataForm)
            .then(({ data: res }) => {
              this.isConfirm = false
              if (res.code !== 0) {
                return this.$message.error(res.msg)
              }
              this.$message({
                message: this.$t("prompt.success"),
                type: "success",
                duration: 500,
                onClose: () => {
                  this.visible = false
                  this.$emit("refreshDataList")
                },
              })
            })
            .catch(() => {
              this.isConfirm = false
            })
        })
      },
      1000,
      { leading: true, trailing: false }
    ),
    // 复核
    examine(type){
      let state = 'AWAIT_RE_CHECK'
      if(type == 'pass'){
        state = 'TAKE_EFFECT'
      }else{
        state = 'RE_CHECK_REFUSE'
      }
      this.isConfirm = true
      this.$http.get(`/system/serviceFees/review/${this.dataForm.batchId}?status=${state}`).then(({ data: res })=>{
        this.isConfirm = false
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.$message({
          message: this.$t("prompt.success"),
          type: "success",
          duration: 500,
          onClose: () => {
            this.visible = false
            this.$emit("refreshDataList")
          },
        })
      })
    },
  },
}
</script>
<style scoped lang="scss">
::v-deep .el-dialog{
  min-width: 840px;
}
.styW{
  width: 340px;
 }
 .styW1{
  width: 100px;
 }
 .styW2{
  width: 70px;
 }
 .sandh{
  width: 100%;
}
.sandh1{
  width: 540px;
  min-width: 500px;
}
 .title{
  font-weight: bold;
  font-size: 16px;
  color: #2cb3a3;
  margin:8px 30px;
 }
 .title1{
  font-weight: bold;
  font-size: 14px;
  margin:8px 40px;
 }
 .condition{
  display: flex;
  justify-content: space-around;
  flex-wrap: nowrap;
 }
 .rate{
  display: flex;
  align-items: center;
 }
 .deleteIcon{
    font-size: 20px;
    color: #333;
    margin-left: 14px;
  }
.add_delete_btn{
  display: flex;
  align-items: center;
}
 
</style>